export default "__VITE_ASSET__HyMWxj24__"